import React, { useContext, useState } from "react";
import axios from "axios";
import styles from "./Login.module.scss"; // Assurez-vous que le chemin est correct
import NavContext from "../../context/NavContext";
//IMG
import logo from "../../pics/logo-hearingspace.png"; 
import audioAvecPatient from "../../pics/audio_avec_patient.png"; 
import animationLogin from "../../pics/animation_login.gif"; 

import LoaderLogin from "../../components/UiComponents/loader/LoaderLogin";
import ForgotPassword from "../../components/authentification/ForgotPassword";

export default function Login({ setRememberMe }) {
  const { loginUser, loaderLogin } = useContext(NavContext);

  const [userMail, setUserMail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showForgot, setShowForgot] = useState(false);

  axios.defaults.withCredentials = true;

  const submitForms = async (e) => {
    e.preventDefault();
    await loginUser(userMail, userPassword);
  };

  return (
    <div className={styles.loginPage}>
       {!showForgot && (
        <>
      <h1 className={styles.titleOne}>Connectez-vous à votre tableau de bord Hearing Space</h1>
      <img src={logo} alt="Logo" className={styles.logo} />
      <header className={styles.header}>
 
      </header>


     
          <div className={styles.heroSection}>
          <div className={styles.leftSide}>
            <h2 className={styles.title}>Bienvenue, reconnectez-vous</h2>
            <form className={styles.loginForm} onSubmit={submitForms}>
              <div className={styles.formGroup}>
                <label htmlFor="email">Identifiant</label>
                <input
                  type="text"
                  id="email"
                  placeholder="User name / Email"
                  value={userMail}
                  onChange={(e) => setUserMail(e.target.value)}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="password">Mot de passe</label>
                <input
                  type="password"
                  id="password"
                  placeholder="Mot de passe"
                  value={userPassword}
                  onChange={(e) => setUserPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className={styles.submitBtn}>
                Connexion
              </button>

              {loaderLogin && <LoaderLogin />}

              <div
                className={styles.forgot}
                onClick={() => setShowForgot(true)}
              >
                Mot de passe oublié ?
 
              </div>
            </form>
          </div>
          <div className={styles.rightSide}>
            <img
              src={audioAvecPatient}
              alt="Cabine audiométrique"
              className={styles.heroImage}
            />
       
     
          </div>
        </div>
           </>)}
 
      {showForgot && (
        <ForgotPassword  showForgot={showForgot} setShowForgot={setShowForgot} />
      )}
    </div>
  );
}
